import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  SOCIAL_LOGIN,
  POST_LOGIN,
  POST_LOGIN_SUCCESS,
  POST_LOGIN_FAIL,
  VERIFY_OTP,
  VERIFY_OTP_SUCCESS,
  VERIFY_OTP_FAIL,
  EMP_VERIFY_OTP_FAIL,
  EMP_VERIFY_OTP_SUCCESS,
  EMP_VERIFY_OTP,
  EMPLOYEE_LOGIN,
  EMPLOYEE_LOGIN_SUCCESS,
  EMPLOYEE_LOGIN_FAIL,
  RESEND_OTP,
  RESEND_OTP_SUCCESS,
  RESEND_OTP_FAIL,
  ADMIN_VERIFY_OTP,
  ADMIN_VERIFY_OTP_SUCCESS,
  ADMIN_VERIFY_OTP_FAIL,
  ADMIN_RESEND_OTP,
  ADMIN_RESEND_OTP_SUCCESS,
  ADMIN_RESEND_OTP_FAIL,
  SUPER_ADMIN_LOGIN,
  SUPER_ADMIN_LOGIN_SUCCESS,
  SUPER_ADMIN_LOGIN_FAIL,
  REPORT_LOGIN,
  REPORT_LOGIN_SUCCESS,
  REPORT_LOGIN_FAIL,
} from "./actionTypes";

export const loginReports = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: REPORT_LOGIN,
  payload: { data, onSuccess, onError },
});

export const loginReportsSuccess = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: REPORT_LOGIN_SUCCESS,
  payload: { data, onSuccess, onError },
});

export const loginReportsFail = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: REPORT_LOGIN_FAIL,
  payload: { data, onSuccess, onError },
});

export const superAdminLogin = (data = {}, onSuccess = () => {}, onError = () => {}) => {
  return {
    type: SUPER_ADMIN_LOGIN,
    payload: { data, onSuccess, onError },
  };
};

export const superAdminLoginSuccess = data => {
  return {
    type: SUPER_ADMIN_LOGIN_SUCCESS,
    payload: data,
  };
};

export const superAdminLoginFail = data => {
  return {
    type: SUPER_ADMIN_LOGIN_FAIL,
    payload: data,
  };
};

export const adminResendOtp = data => {
  return {
    type: ADMIN_RESEND_OTP,
    payload: data,
  };
};

export const adminResendOtpSuccess = data => {
  return {
    type: ADMIN_RESEND_OTP_SUCCESS,
    payload: data,
  };
};

export const adminResendOtpFail = data => {
  return {
    type: ADMIN_RESEND_OTP_FAIL,
    payload: data,
  };
};

export const adminVerifyOtp = (data, history) => {
  return {
    type: ADMIN_VERIFY_OTP,
    payload: { data, history },
  };
};

export const adminVerifyOtpSuccess = data => {
  return {
    type: ADMIN_VERIFY_OTP_SUCCESS,
    payload: data,
  };
};

export const adminVerifyOtpFail = data => {
  return {
    type: ADMIN_VERIFY_OTP_FAIL,
    payload: data,
  };
};

export const resendOtp = data => {
  return {
    type: RESEND_OTP,
    payload: data,
  };
};

export const resendOtpSuccess = data => {
  return {
    type: RESEND_OTP_SUCCESS,
    payload: data,
  };
};

export const resendOtpFail = data => {
  return {
    type: RESEND_OTP_FAIL,
    payload: data,
  };
};

export const empVerifyOtp = (data, history) => {
  return {
    type: EMP_VERIFY_OTP,
    payload: { data, history },
  };
};

export const empVerifyOtpSuccess = data => {
  return {
    type: EMP_VERIFY_OTP_SUCCESS,
    payload: data,
  };
};

export const empVerifyOtpFail = data => {
  return {
    type: EMP_VERIFY_OTP_FAIL,
    payload: data,
  };
};

export const empLogin = (data, onSuccess = () => {}, onError = () => {}, header = {}) => {
  return {
    type: EMPLOYEE_LOGIN,
    payload: { data, onSuccess, onError, header },
  };
};

export const empLoginSuccess = data => {
  return {
    type: EMPLOYEE_LOGIN_SUCCESS,
    payload: data,
  };
};

export const empLoginFail = data => {
  return {
    type: EMPLOYEE_LOGIN_FAIL,
    payload: data,
  };
};

export const verifyOtp = (data = {}, onSuccess = () => {}, onError = () => {}, header = {}, history, dispatch) => {
  return {
    type: VERIFY_OTP,
    payload: { data, onSuccess, onError, header, history, dispatch },
  };
};

export const verifyOtpSuccess = data => {
  return {
    type: VERIFY_OTP_SUCCESS,
    payload: data,
  };
};

export const verifyOtpFail = data => {
  return {
    type: VERIFY_OTP_FAIL,
    payload: data,
  };
};

export const postloginUser = (data = {}, onSuccess = () => {}, onError = () => {}, header = {}) => {
  return {
    type: POST_LOGIN,
    payload: { data, onSuccess, onError, header },
  };
};

export const postloginSuccess = user => {
  return {
    type: POST_LOGIN_SUCCESS,
    payload: user,
  };
};

export const postloginFail = user => {
  return {
    type: POST_LOGIN_FAIL,
    payload: user,
  };
};

export const loginUser = (user, history) => {
  return {
    type: LOGIN_USER,
    payload: { user, history },
  };
};

export const loginSuccess = user => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  };
};

export const logoutUser = history => {
  return {
    type: LOGOUT_USER,
    payload: { history },
  };
};

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  };
};

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

export const socialLogin = (data, history, type) => {
  return {
    type: SOCIAL_LOGIN,
    payload: { data, history, type },
  };
};
